import type { SnackbarInput, SnackbarState } from '@/components/NewUI/ComponentsLibrary';

import type { SingleRootFlashMessage } from './types';

/** A shell snackbar; `durationMs` overrides the wrapper's 2 seconds. */
export interface ShellSnackbarInput extends SnackbarInput {
  durationMs?: number;
}

export type ShellNotify = (input: ShellSnackbarInput) => void;

// A flash often explains a redirect the user did not ask for; 2 seconds is too short to read it.
export const FLASH_DURATION_MS = 6000;

// The server retypes a legacy `notice` that is not a confirmation (SingleRoot::FlashPresenter).
export const flashState = (type: string): SnackbarState => {
  if (type === 'success' || type === 'notice') return 'success';
  if (type === 'alert' || type === 'error') return 'error';
  return 'warning';
};

export const flashSnackbar = ({ text, type }: SingleRootFlashMessage): ShellSnackbarInput => ({
  message: text,
  state: flashState(type),
  durationMs: FLASH_DURATION_MS
});

// The snackbar shows one message: a document's first flash entry.
export const firstFlash = (flash: SingleRootFlashMessage[]): ShellSnackbarInput => {
  const [entry] = flash;
  return entry ? flashSnackbar(entry) : { message: '', state: 'success' };
};
